/* Project Import will be here */
import { post, IRequest } from "./index";
/* Project Import will be here */

export const GetCheckoutSummaryApi = () => {
    const request: IRequest = { subUrl: `/SalesOrder/GetCheckoutSummary` };
    return post(request);
};